/**
 * Plan 462 M5: the buyer-facing words of the "haven't heard from your agent"
 * exit, in ONE file.
 *
 * DRAFT COPY (question 338): the operator's copy pass is a one-file edit
 * here. Nothing else in the app spells these strings, and the tests import
 * the constants rather than pinning literals, so changing a word never
 * touches a component.
 *
 * The card ASKS rather than asserts (Sill cannot see phone calls), and the
 * option is never called a "release".
 */

/** Banner headline. */
export function noContactExitHeadline(proName: string): string {
  return `Haven't heard from ${proName}?`;
}

/** Banner body. */
export function noContactExitBody(proName: string): string {
  return `If ${proName} hasn't reached out, you can end this connection.`;
}

/** Banner button, which opens the disconnect dialog. */
export const NO_CONTACT_EXIT_BUTTON = "End connection";

/** The unchecked-by-default choice the dialog adds when opened from the banner. */
export const NO_CONTACT_EXIT_REPUBLISH_LABEL =
  "Put my passport back on the market";

/** Done-state sentence when the server confirms the passport was published again. */
export const NO_CONTACT_EXIT_DONE_REPUBLISHED =
  "Your passport is back on the market.";
